import moment from 'moment';

class IndicadoresReportesAPI {
    checkStatus(response) {
        switch (response.status) {
            case 500: //Error 500 del Servidor
                throw new Error(`${response.status} - Server Error!`);
                break;
            default:
                console.log("Success Response");
                break;
        }
    }

    //Cierre de Recibos de Caja
    async listClosuresOfCashReceipts(params) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}reportes/reporte-cierre-recibocaja`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(params)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
        });
        return datos;
    }

    //reportes/reporte-cierre-recibocaja-zero
    async listClosuresOfCashReceiptsZero(params) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}reportes/reporte-cierre-recibocaja-zero`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(params)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
        });
        return datos;
    }

    //reportes/admisiones-part-sin-recibo
    async listParticularAdmissionsWithoutReceipt(params) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}reportes/admisiones-part-sin-recibo`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(params)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
        });
        return datos;
    }

    //Reporte de Pacientes Atendidos por Diagnostico
    async listPatientsForDiagnostic(params) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}reportes/pacientes-atendidos/diagnostico`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(params)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
        });
        return datos;
    }

    //Reporte de Diario de Operaciones
    async operationsDiary(params) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}reportes/impresion-citas`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(params)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
        });
        return datos;
    }

    async operationsDiaryReport(params) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}reportes/diario-operaciones`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(params)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
        });
        return datos;
    }

   
    
    //Reporte cierre de facturación
    async blligReportDates(params) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}reportes/facturacion`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(params)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
        });
        return datos;
    }

    loadCity = async (id) => {
        let data = { id: id };
        let datos;
        //console.log(data);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'ciudades/consultarXID', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                datos = data.contenido;
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        return datos
    }

    loadDepartment = async () => {
        let datos;
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'departamentos/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log(data);
                datos = data;
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        return datos
    }

    loadCauseOfMorbidity = (fInicio, fFinal) => {
        return new Promise((resolve, reject) => {
            let fInicialFilter = moment(fInicio).format("YYYY/MM/DD");
            let fFinalFilter = moment(fFinal).format("YYYY/MM/DD");
            fetch(process.env.REACT_APP_PUBLIC_URL + 'reportes/causas-morbilidad', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    fecha_inicial: moment(fInicialFilter + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
                    fecha_final: moment(fFinalFilter + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss')
                })
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error('Data');
                }
            }).then(data => {
                resolve(data);
            }).catch((error) => {
                console.error('Error:', error);
                reject(null);
            });
        });
    }

    loadDetailedSurcharges = (fInicio, fFinal, idFactura) => {
        return new Promise((resolve, reject) => {
            let fInicialFilter = moment(fInicio).format("YYYY/MM/DD");
            let fFinalFilter = moment(fFinal).format("YYYY/MM/DD");
            fetch(process.env.REACT_APP_PUBLIC_URL + 'reportes/detallado-recargos', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    fecha_inicial: moment(fInicialFilter + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
                    fecha_final: moment(fFinalFilter + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
                    id_factura_t: idFactura
                })
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error('Data');
                }
            }).then(data => {
                resolve(data);
            }).catch((error) => {
                console.error('Error:', error);
                reject(null);
            });
        });
    }

    async amountOfAppointmentsByProfessional(params) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}reportes/impresion-citas-cant-services`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(params)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
        });
        return datos;
    }

    loadFormMNPReport = (fInicio, fFinal, id_tercero, id_contrato) => {
        return new Promise((resolve, reject) => {
            let fInicialFilter = moment(fInicio).format("YYYY-MM-DD");
            let fFinalFilter = moment(fFinal).format("YYYY-MM-DD");
            fetch(process.env.REACT_APP_PUBLIC_URL + 'reportes/planilla-mnp', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    fecha_inicial: moment(fInicialFilter + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
                    fecha_final: moment(fFinalFilter + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
                    id_tercero: !!id_tercero ? id_tercero : null, 
                    id_contrato: !!id_contrato ? id_contrato : null
                })
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error('Data');
                }
            }).then(data => {
                resolve(data);
            }).catch((error) => {
                console.error('Error:', error);
                reject(error);
            });
        });
    }

    loadThird = (id_tercero) => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'tercero/ver/' + id_tercero, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    resolve(data.contenido[0]);
                })
                .catch((error) => {
                    resolve([]);
                    console.error('Error:', error);
                });
        })
    }

}


export default new IndicadoresReportesAPI();